import React from 'react';

const Triangle = () => {
  return <div className="triangle"></div>;
};

export default Triangle;